import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { RTL_LANGS } from "@/i18n";

const LangCtx = createContext(null);

export function LangProvider({ children }) {
  const { user, setLanguageOnServer } = useAuth();
  const [lang, setLangState] = useState(() => localStorage.getItem("nvc_lang") || "es");

  useEffect(() => {
    if (user?.language) {
      setLangState(user.language);
      localStorage.setItem("nvc_lang", user.language);
    }
  }, [user?.language]);

  useEffect(() => {
    // Update html attributes for RTL + a11y
    document.documentElement.lang = lang;
    document.documentElement.dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
  }, [lang]);

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("nvc_lang", l);
    if (user) setLanguageOnServer(l);
  };

  return <LangCtx.Provider value={{ lang, setLang }}>{children}</LangCtx.Provider>;
}

export function useLang() {
  return useContext(LangCtx);
}
